import jwt_decode from 'jwt-decode';

import CookieService from '../CookieService';

import {AppConfig} from '../../lib/AppConfig';

// Exported functions
function isUserLoggedIn(): boolean {
  const userCookie = CookieService.getUserCookie();
  return isValidCookie(userCookie) ? true : false;
}

function clearLinkedInLocalStorage(): void {
  localStorage.removeItem(AppConfig.LOCAL_STORAGE_LINKEDIN_PUBLIC_PROFILE_URL);
  localStorage.removeItem(AppConfig.LOCAL_STORAGE_LINKEDIN_PUBLIC_PICTURE_URL);
  localStorage.removeItem(AppConfig.LOCAL_STORAGE_LINKEDIN_AUTH_CODE_KEY);
  localStorage.removeItem(AppConfig.LOCAL_STORAGE_LINKEDIN_STATE_KEY);
  localStorage.removeItem(AppConfig.LOCAL_STORAGE_LINKEDIN_ERROR_KEY);
}

function logout(): void {
  CookieService.clearCookie();
  clearLinkedInLocalStorage();
}

function forceLogout(): void {
  window.location.href = AppConfig.LOGIN_PATH;
  logout();
  localStorage.setItem(AppConfig.LOCAL_STORAGE_SESSION_EXPIRED_KEY, 'true');
}

function getUserAuthToken(): string | null {
  const userCookie = CookieService.getUserCookie();

  if (!userCookie) {
    return null;
  }

  if (isTokenExpired(userCookie.token)) {
    forceLogout();
    return null;
  }

  return isValidCookie(userCookie) ? userCookie.token : null;
}

const isTokenExpired = (token: string) => {
  const decodedToken: any = jwt_decode(token);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp < currentTime;
};

function isValidCookie(cookie: any): boolean {
  if (!cookie) {
    return false;
  }

  const token = cookie.token;

  const decoded_token: any = jwt_decode(token);
  const token_subject = decoded_token.sub;

  return token_subject === cookie.id ? true : false;
}

export {isUserLoggedIn, logout, getUserAuthToken, isTokenExpired, isValidCookie, forceLogout};

// Non-exported functions
